import React from 'react';

import { Box, Inline } from '@styleseat/ui';
import { colors } from '@styleseat/brand';
import { BasicDotIcon } from '../Icons/BasicDotIcon';

export type BullettedListItemProps = {
  color?: string;
  size?: number;
  padding?: any;
};

export const BullettedListItem: React.FC<BullettedListItemProps> = ({
  size = 8,
  padding = 16,
  children,
}) => (
  <Inline alignItems="center">
    <Box paddingRight={padding}>
      <BasicDotIcon color={colors.metal} height={size} width={size} />
    </Box>
    {children}
  </Inline>
);
